import useSWR from "swr";
import { fetcher } from "src/utils/fetcher";

export default function useSummaryDebt(params) {
  return useSWR(
    {
      path: "/api/v1/inventory-notes/summary-debt",
      method: "GET",
      params,
    },
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}
